import MuiLink from '@material-ui/core/Link';
import React from 'react';
import { Link } from 'react-router-dom';
import CalculationActions from './CalculationActions';

export const calculationFormatter = (cell, row) => (
  <MuiLink variant="subtitle1" component={Link} to={`/calculations/${row.id}`}>
    {cell && cell !== '' ? cell : 'concept'}
  </MuiLink>
);

export const actionsFormatter = (cell, row) => <CalculationActions calculation={row} />;

export default actionsFormatter;
